import * as Yup from "yup"; // Import Yup

// {
//   value: email | password
// }

const signUpValidationSchema = Yup.object().shape({
  value: Yup.string().required("Email or Phone Number is required"),
});

export default signUpValidationSchema;
